import HttpClient from '../HttpService';

function list() {
    return HttpClient.get('/auth/sessions');
}

function logoutDevice(deviceId) {
    return HttpClient.delete(`/auth/sessions/${deviceId}`);
}

export default { list, logoutDevice }
